import React, { useState } from 'react';
import './css/paymentWarningBanner.css';

const translations = {
  nl: {
    warningTitle: 'Openstaande factuur',
    warningMessage: 'Er staat een factuur open. Gelieve uw saldo te vereffenen.',
    criticalTitle: 'Dringende betaling vereist – account wordt bevroren',
    criticalMessage: 'Uw account wordt bevroren als de factuur niet wordt betaald. Neem onmiddellijk contact met ons op.',
    contactUs: 'Contacteer ons',
    close: 'Sluiten',
  },
  en: {
    warningTitle: 'Payment overdue',
    warningMessage: 'You have an outstanding payment. Please settle your balance.',
    criticalTitle: 'Urgent payment required',
    criticalMessage: 'Your account will be frozen if payment is not received. Please contact us immediately.',
    contactUs: 'Contact us',
    close: 'Close',
  },
  fr: {
    warningTitle: 'Paiement en retard',
    warningMessage: 'Vous avez un paiement en souffrance. Veuillez régler votre solde.',
    criticalTitle: 'Paiement urgent requis',
    criticalMessage: 'Votre compte sera gelé si le paiement n\'est pas reçu. Veuillez nous contacter immédiatement.',
    contactUs: 'Contactez-nous',
    close: 'Fermer',
  },
};

export default function PaymentWarningBanner({ paymentStatus }) {
  const [dismissed, setDismissed] = useState(() => {
    return sessionStorage.getItem('paymentWarningDismissed') === 'true';
  });

  if (paymentStatus !== "warning" && paymentStatus !== "critical") return null;
  if (dismissed) return null;

  const lang = localStorage.getItem('preferredLanguage') || 'nl';
  const t = translations[lang] || translations.nl;
  const isCritical = paymentStatus === "critical";

  return (
    <div className="payment-warning-component">
      <div
        className={`payment-warning-banner ${isCritical ? 'payment-critical' : 'payment-warning'}`}
        role="alert"
        aria-live="assertive"
      >
        <div className="payment-warning-banner__content">
          <div className="payment-warning-banner__text">
            <strong className="payment-warning-banner__title">
              {isCritical ? t.criticalTitle : t.warningTitle}
            </strong>
            <span className="payment-warning-banner__message">
              {isCritical ? t.criticalMessage : t.warningMessage}
            </span>
          </div>

          <div className="payment-warning-banner__actions">
            <button
              className="payment-warning-banner__close"
              onClick={() => {
                sessionStorage.setItem('paymentWarningDismissed', 'true');
                setDismissed(true);
              }}
              aria-label={t.close}
              title={t.close}
            >
              ×
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
